import Index from "../components/Positions/index";

const Positions = () => {
    return <Index />;
};

export default Positions;
